import { gql } from '@apollo/client/core';

export const imageBlockFragment = gql`
  fragment ImageBlockFields on ImageBlock {
    image {
      url
      title
    }
    altText
    description
    imageTitle
  }
`;
